import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CapitalizePipe } from 'app/pipes/capitalize.pipe';
import { DateFormatPipeEx } from 'app/pipes/date-format.pipe';
import { ReversePipe } from 'app/pipes/reverse.pipe';

@NgModule({
    declarations: [
        CapitalizePipe,
        DateFormatPipeEx,
        ReversePipe
    ],
    imports: [CommonModule],
    exports: [
        CapitalizePipe,
        DateFormatPipeEx,
        ReversePipe
    ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts